import { store } from "rfx-core";

import AppState from "./AppState";

export default store.setup({
	appState: AppState
});



// WEBPACK FOOTER //
// ./src/stores/stores.js